// Getters

// Actions
export const GET_REQUEST = 'getRequest'
export const REQUEST_POOLS = 'requestPools'

export const WS_REQUEST_POOLS = 'websentinel/' + REQUEST_POOLS

// Mutations



// WEBPACK FOOTER //
// ./src/store/websentinel/websentinel.types.js